import { render } from "./downloadBackup.vue?vue&type=template&id=a8dc5fdc&scoped=true"
import script from "./downloadBackup.vue?vue&type=script&lang=js"
export * from "./downloadBackup.vue?vue&type=script&lang=js"

import "./downloadBackup.vue?vue&type=style&index=0&id=a8dc5fdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8dc5fdc"]])

export default __exports__